module.exports = __webpack_public_path__ + "img/xemhd.0865b64d.svg";